import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const ObservatoryModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Observatório">
          <g id="background_2_">
            <g id="group200_2_">
              <path
                id="_x32_00_2_"
                fill={fillColor200}
                opacity="0.25"
                d="M186.9,489c7,84.7,58.9,162.9,142.8,198.4c112.1,47.4,244-0.4,301.4-109.3
				c0.4-0.7,0.8-1.5,1.1-2.2c15.7-30.5,38.4-56.6,65.6-77.4c19.2-14.7,35-34.4,45.1-58.5c29.9-70.9-1.9-153.5-71.1-185
				c-26.8-12.2-94.1-16.7-145.8-19.2c-34.8-1.7-66.1-20.8-84.2-50.8c-20.5-34-52-61.8-92.2-77.5c-89.4-34.8-192.4,5.1-236.5,91.5
				c-41.1,80.6-20.1,175.2,44,230.5C174.5,444.6,185,466,186.9,489z"
              />
            </g>
            <g id="group400_2_">
              <path
                id="_x34_00_6_"
                fill={fillColor400}
                opacity="0.2"
                d="M614.3,242.7c6-41.8-10.5-85.5-47.3-111.9c-49.1-35.4-118.3-26.7-158.2,19.7
				c-0.3,0.3-0.5,0.6-0.8,0.9c-11,13.1-24.8,23.2-40.3,30.3c-10.9,5-20.8,12.8-28.3,23.4c-22.3,31-16,74.6,14.1,97.5
				c11.7,8.9,43.8,18.5,68.5,25.4c16.7,4.7,28.3,12.3,33.7,28.8c6.2,18.8,34,41,59.4,39.8c47.6-2.2,56-12.9,88-49
				c14.3-16.2,38.3-30.4,13.4-64.3C609.7,274.1,612.7,254.1,614.3,242.7z"
              />
              <path
                id="_x34_00_5_"
                fill={fillColor400}
                opacity="0.2"
                d="M435.1,493.6c-13.6,40-5.3,85.9,26,118.7c41.8,43.8,111.4,48,159.1,9.6
				c0.3-0.3,0.6-0.5,1-0.8c13.2-10.8,28.7-18.2,45.2-22.4c11.6-2.9,22.8-8.8,32.1-17.8c27.7-26.4,29.4-70.4,4.1-98.5
				c-9.8-10.9-39.6-26.2-62.7-37.5c-15.6-7.6-25.5-17.3-27.9-34.5c-2.6-19.6-25.9-46.5-51.1-50c-47.2-6.5-57.4,2.4-95.5,32.1
				c-17.1,13.3-43.3,22.9-25,60.7C445.4,463.6,438.8,482.8,435.1,493.6z"
              />
              <path
                id="_x34_00_4_"
                fill={fillColor400}
                opacity="0.2"
                d="M110.7,398.4C73.8,419,49.1,458.6,50.4,503.9C52,564.4,100.9,614.2,162,617.7
				c0.4,0,0.8,0,1.2,0.1c17,0.8,33.5,5.7,48.5,13.7c10.6,5.7,22.8,8.7,35.8,8.4c38.2-1.1,69.1-32.5,69-70.3
				c0-14.7-11.9-46-21.4-69.9c-6.4-16.1-7.3-29.9,2.5-44.3c11.2-16.3,12-51.9-4.3-71.3c-30.7-36.5-44.2-36.7-92.3-40.2
				c-21.6-1.6-47.4-12-59.2,28.3C138.5,383.1,120.7,392.8,110.7,398.4z"
              />
            </g>
            <g id="group600_2_">
              <path
                id="_x36_00_8_"
                fill={fillColor600}
                d="M604,197.7c0,0,117.3,88.7,92.7,190.9c-24.6,102.3-13.5,102.1-40.4,167.7
				c-36.6,89.4-104.6,109.2-164.8,134.3s-161.6,15.8-199.7-12.4s-46.9-83-56.2-108.3c-8.5-23.3-29.6-104.1-79.6-131.5
				C83.1,398.4,27.3,405,14.7,340C8,305,46.7,245.6,134.2,204.1c79.5-37.7,139.4-54.8,175.1-54.1c51,0.9,105.3,36.9,134,48.9
				C481,214.7,517.6,138.9,604,197.7z"
              />
              <path
                id="_x36_00_7_"
                fill={fillColor600}
                d="M730.6,479.9c13.4-1.1,24.2-9.8,28.7-21.4c2.1-5.3,7-8.8,12.6-9c0.1,0,0.2,0,0.2,0
				c7.6-0.4,14.1-6,15.5-13.4c1.9-9.9-5.1-19-14.9-19.9c-3-0.3-5.8,0.3-8.4,1.4c-6.5,3-14.1,2.3-20.4-1.2c-6.2-3.4-13.5-4.9-21-3.8
				c-18.7,2.7-31.6,20.1-28.6,38.8C697.2,468.8,713.1,481.3,730.6,479.9z"
              />
              <path
                id="_x36_00_6_"
                fill={fillColor600}
                d="M164.1,463.1c10.7,12,4,35.6-8.1,46.3c-12,10.7-24.7,4.6-35.5-7.4
				c-10.7-12-19.5-41.5-7.5-52.2C125.1,439,153.4,451.1,164.1,463.1z"
              />
              <path
                id="_x36_00_5_"
                fill={fillColor600}
                d="M466.2,154.1c7,6.3,7.5,17.1,1.2,24.1c-6.3,7-17.1,7.5-24.1,1.2c-7-6.3-20.8-16.5-14.5-23.5
				C435.1,149,459.2,147.8,466.2,154.1z"
              />
            </g>
          </g>
          <g>
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              d="M264.4,650.5l123.9-175.9"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M590.8,165.6L643.1,292c5.8,13.9-0.8,29.9-14.8,35.7l-23.2,9.6c-27.9,11.6-59.9-1.7-71.5-29.6l-31.4-75.8
			c-11.6-27.9,1.7-59.9,29.6-71.5l23.2-9.6C569,145,585,151.6,590.8,165.6z"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M533.7,307.7l-31.4-75.8c-5.8-13.9-21.8-20.6-35.7-14.8l-227.4,94.2c-13.9,5.8-20.6,21.8-14.8,35.7l31.4,75.8
			c5.8,13.9,21.8,20.6,35.7,14.8l227.4-94.2C532.8,337.7,539.4,321.7,533.7,307.7z"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M255.7,422.8L224.3,347l-50.5,20.9c-13.9,5.8-20.6,21.8-14.8,35.7l10.5,25.3c5.8,13.9,21.8,20.6,35.7,14.8
			L255.7,422.8z"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill={fillBG}
              d="M461.3,401.7c20.1,20.1,20.1,52.8,0,72.9c-20.1,20.1-52.8,20.1-72.9,0c-20.1-20.1-20.1-52.8,0-72.9
			C408.6,381.6,441.2,381.6,461.3,401.7"
            />
            <path
              stroke={strokeColor900}
              strokeWidth={strokenWidth}
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
              d="M592.6,650.5L461.4,474.7"
            />
          </g>
        </g>
      </svg>
    </Box>
  )

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <path
          fill={fillColor200}
          opacity="0.25"
          d="M571.92,638.77C653.34,547,839,445.33,755.76,345.47c-58-69.6-253.93-156.8-468.88-184.77C-263.25,89.13,264.27,985.52,571.92,638.77Z"
          transform="translate(-47.24 -73.83)"
        />
        <g>
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M270.84,637.38c1.83,38.34,24,74.4,61.34,91.71,49.85,23.11,110.06,3.6,137.65-44.65.18-.32.37-.64.55-1a104.21,104.21,0,0,1,30.77-33.88,64.91,64.91,0,0,0,21.27-25.68c14.61-31.5,1.53-69.27-29.22-84.55-11.91-5.92-42.2-9-65.45-10.9-15.69-1.3-27.31-6.15-35-19.92C384,492.88,355.46,477.79,333,483.2c-42.09,10.16-47.76,21.09-70,58.77-10,16.9-29,33.67-.95,59.59C269.63,608.59,270.35,627,270.84,637.38Z"
            transform="translate(-47.24 -73.83)"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M397,183.33c-13.32-34.19-45.33-60.88-86.07-66.57-54.42-7.59-105.81,26.14-117.48,77.15-.08.34-.15.68-.23,1a93.55,93.55,0,0,1-19,38.86,58.18,58.18,0,0,0-12.47,28.92c-4.38,32.39,19.48,63.06,53.35,68.67,13.12,2.18,42.86-3.14,65.57-7.62,15.32-3,27.84-1.73,39.31,8.68,13,11.83,44.79,17.84,64.49,7,37-20.43,39.07-31.83,48.88-71.87,4.41-18,17.39-38.2-17.1-54.16C406.89,209.06,400.65,192.62,397,183.33Z"
            transform="translate(-47.24 -73.83)"
          />
          <path
            fill={fillColor400}
            opacity="0.2"
            d="M646.49,505.57c38.3-2.4,74-25.13,90.78-62.7,22.37-50.19,2-110.1-46.69-137l-1-.53a104.17,104.17,0,0,1-34.34-30.27,64.85,64.85,0,0,0-26-20.88c-31.72-14.14-69.29-.5-84.11,30.47-5.74,12-8.35,42.33-9.92,65.61-1.06,15.7-5.74,27.4-19.4,35.28-15.53,9-30.18,37.76-24.44,60.11,10.78,41.92,21.79,47.43,59.8,69.15,17,9.75,34.11,28.46,59.6.06C617.72,507.21,636.09,506.22,646.49,505.57Z"
            transform="translate(-47.24 -73.83)"
          />
        </g>
        <path
          fill={fillColor600}
          d="M121.91,631.69c6.29,12,20.08,17.35,39.9,23.61,18.25,5.76,37-1.85,39.38-4.8,10.9-13.69-30.26-44.52-42.26-43.22C145.3,608.74,113.25,615.18,121.91,631.69Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M689.12,537.16c4.81-25-23.48-22.66-33.91-15.09-12.62,9.17,12.24,41.06,25,50.88C700.65,585.18,687,548.43,689.12,537.16Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M469,645c128-53.93,271.74-260.46,189.17-421.93-49.69-97.2-265.41,28.33-382.63-12.29C171.13,174.59,19.29,834.48,469,645Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          fill={fillColor600}
          d="M203.15,143.57c.45-29.66,37.38,1.33,46.65,15.39s.95,26.27-13.11,35.53-45.83,13.85-55.09-.21S202.55,182.86,203.15,143.57Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M319.25,492.5v99.67h99.67V492.5"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M506.13,243.33H232a87.21,87.21,0,0,0-87.2,87.21v137a24.92,24.92,0,0,0,24.91,24.92H568.42a24.93,24.93,0,0,0,24.92-24.92v-137A87.22,87.22,0,0,0,506.13,243.33Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M219.59,343H244.5"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M418.92,168.58V343"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill={fillBG}
          d="M418.92,93.83H543.5v74.75H418.92Z"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M418.89,333.66a9.34,9.34,0,1,0,9.37,9.34,9.36,9.36,0,0,0-9.37-9.34"
          transform="translate(-47.24 -73.83)"
        />
        <path
          stroke={strokeColor900}
          strokeWidth={strokenWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          d="M232,243.33a87.21,87.21,0,0,1,87.21,87.21v162"
          transform="translate(-47.24 -73.83)"
        />
      </svg>
    </Box>
  )
}

export default memo(ObservatoryModuleBrand)
